import { BrowserRouter, Route, Switch } from "react-router-dom";
import { AddressPage } from "../pages/AddressPage";
import { BaladaProtect } from "../pages/BaladaProtect";
import { ConfirmationPage } from "../pages/ConfirmationPage";
import { HomePage } from "../pages/HomePage";
import { PaymentPage } from "../pages/PaymentPage";
import { PyamentAproved } from "../pages/PyamentAproved";
import { PyamentFail } from "../pages/PyamentFail";

import { PyamentPending } from "../pages/PyamentPending";
import { ReviewPage } from "../pages/ReviewPage";
import { SellerNotFoundPage } from "../pages/SellerNotFoundPage";
import { UserCardPage } from "../pages/UserCardPage";
import { EwqAddressPage } from "../templates/ewq/pages/EwqAddressPage";
import { EwqHomePage } from "../templates/ewq/pages/EwqHomePage";
import { EwqPaymentPage } from "../templates/ewq/pages/EwqPaymentPage";
import { EwqPyamentAproved } from "../templates/ewq/pages/EwqPyamentAproved";
import { EwqPyamentFail } from "../templates/ewq/pages/EwqPyamentFail";
import { EwqPyamentPending } from "../templates/ewq/pages/EwqPyamentPending";
import { EwqReviewPage } from "../templates/ewq/pages/EwqReviewPage";
import { DependentsPage } from "../pages/DependentsPage";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/balada-protect" component={BaladaProtect} />
      <Route path="/ewq/endereco" component={EwqAddressPage} />
      <Route path="/ewq/revisao" component={EwqReviewPage} />
      <Route path="/ewq/pagamento" component={EwqPaymentPage} />
      <Route path="/ewq/sucesso" component={EwqPyamentAproved} />
      <Route path="/ewq/falha" component={EwqPyamentFail} />
      <Route path="/ewq/pendente/:id" component={EwqPyamentPending} />

      <Route path="/ewq/" component={EwqHomePage} />

      <Route path="/errorsellercode" component={SellerNotFoundPage} />
      <Route path="/confirmacao" component={ConfirmationPage} />

      <Route path="/cartao" component={UserCardPage} />
      <Route path="/falha" component={PyamentFail} />
      <Route path="/sucesso" component={PyamentAproved} />
      <Route path="/pendente/:id" component={PyamentPending} />
      <Route path="/endereco" component={AddressPage} />
      <Route path="/dependentes" component={DependentsPage} />
      <Route path="/revisao" component={ReviewPage} />
      <Route path="/pagamento" component={PaymentPage} />
      <Route path="/" component={HomePage} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
